import { assertExists } from '@blocksuite/global/utils';
export class Slice {
    static fromModels(page, models) {
        const meta = page.workspace.meta;
        const { pageVersion, workspaceVersion } = meta;
        assertExists(pageVersion);
        assertExists(workspaceVersion);
        return new Slice({
            content: models,
            workspaceId: page.workspace.id,
            pageId: page.id,
            blockVersions: { ...meta.blockVersions },
            pageVersion,
            workspaceVersion,
        });
    }
    constructor(data) {
        this.data = data;
    }
    get content() {
        return this.data.content;
    }
    get blockVersions() {
        return this.data.blockVersions;
    }
    get pageVersion() {
        return this.data.pageVersion;
    }
    get workspaceVersion() {
        return this.data.workspaceVersion;
    }
    get workspaceId() {
        return this.data.workspaceId;
    }
    get pageId() {
        return this.data.pageId;
    }
}
//# sourceMappingURL=slice.js.map